import * as React from "react";
const SvgFilterSolid = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M2.27388 5.859C2.738 4.87451 3.72249 4.24866 4.81246 4.24866H35.191C36.281 4.24866 37.2655 4.87451 37.7296 5.859C38.1937 6.84349 38.0531 8.00378 37.3639 8.84763L24.5023 24.5643V33.5021C24.5023 34.353 24.0241 35.1335 23.2576 35.5133C22.4911 35.893 21.584 35.8156 20.9018 35.3023L16.4013 31.9269C15.8317 31.505 15.5012 30.8369 15.5012 30.1267V24.5643L2.63252 8.8406C1.95041 8.00378 1.80273 6.83646 2.27388 5.859Z" }));
export default SvgFilterSolid;
